import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, Util, Image, Button } from '@grandvisionhq/common';
import { BannerTooltip } from '@grandvisionhq/content';
import { Heading, Text } from '@grandvisionhq/elements';

const ClickableImageWrapper = ({ url , children , ctaLabel , ariaLabel  })=>{
    const sharedProps = {
        className: 'promotion-block__link',
        'data-t': 'promotion-block-image'
    };
    if (!url) {
        return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, sharedProps), children);
    }
    return /*#__PURE__*/ React.createElement("a", swcHelpers.extends({
        href: url,
        tabIndex: ctaLabel ? -1 : undefined,
        "aria-hidden": ctaLabel ? 'true' : undefined,
        //For now, the alt field is mandatory in Bloomreach. It will change in the future
        //based on the label link and a showLabel yes/no checkbox
        "aria-label": ctaLabel ? undefined : ariaLabel
    }, sharedProps), children);
};
const PromotionBlock = /*#__PURE__*/ React.forwardRef(({ id , title , description , image , links , size , onClick , ctaLabel , manageContentButton , tooltip  }, ref)=>{
    const imageUrl = MediaQuery.useIsPhone() ? image === null || image === void 0 ? void 0 : image.mobileUrl : image === null || image === void 0 ? void 0 : image.url;
    if (!imageUrl) {
        return null;
    }
    const buttonStyles = (links === null || links === void 0 ? void 0 : links.style) ? Util.createButtonStyles(links.style) : {};
    const classNames = classnames('promotion-block', {
        'promotion-block--overlay': !!title || !!description,
        'promotion-block--large': size === 'large',
        'promotion-block--without-text': !title || !description
    });
    const promotionInfoId = `promotion-info-${id}`;
    const { url , alt  } = links || {};
    const showCta = Boolean(!!ctaLabel && (url || onClick));
    const imageAlt = showCta ? '' : image === null || image === void 0 ? void 0 : image.description;
    return /*#__PURE__*/ React.createElement("div", {
        "data-t": "promotion-block",
        ref: ref,
        className: classNames
    }, manageContentButton, /*#__PURE__*/ React.createElement(ClickableImageWrapper, {
        url: url,
        ctaLabel: ctaLabel,
        ariaLabel: alt
    }, /*#__PURE__*/ React.createElement(Image, {
        url: imageUrl,
        "aria-hidden": !!url,
        alt: imageAlt,
        cover: true,
        className: "promotion-block__image"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "promotion-block__inner"
    }, (title || description) && /*#__PURE__*/ React.createElement("div", {
        className: "promotion-block__text",
        id: promotionInfoId
    }, title && /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "medium",
        className: "promotion-block__title"
    }, title), description && /*#__PURE__*/ React.createElement(Text, {
        variant: "body",
        className: "promotion-block__subtitle"
    }, description)), showCta && /*#__PURE__*/ React.createElement(Button, swcHelpers.extends({}, buttonStyles, {
        className: "promotion-block__button",
        "data-t": "promotion-block-button",
        size: "custom",
        onClick: onClick,
        href: url,
        caption: ctaLabel
    })), tooltip && tooltip.showTooltip && /*#__PURE__*/ React.createElement(BannerTooltip, {
        className: "promotion-block__tooltip",
        tooltip: tooltip
    })));
});

export { PromotionBlock };
//# sourceMappingURL=PromotionBlock.js.map
